import { createApiInstance } from "./api";

const conversationsApiInstance = createApiInstance("/backoffice/conversations");

// A spec pede polling na v1 ("refresh every 5 to 10s"). O tick nao mostra
// spinner: um piscar de dez em dez segundos numa lista que o operador esta a ler
// e pior do que nao atualizar. Por isso tambem nao ha botao de recarregar: um
// botao ao lado de um poll silencioso so ensina o operador a desconfiar do poll.
// A lista e a transcricao do mesmo ecra leem daqui, e nao cada uma do seu
// numero: eram duas constantes iguais e so uma trazia esta razao escrita.
export const POLL_MS = 10000;

// So para o pedido do anexo, e nao na instancia partilhada: as outras chamadas
// devolvem JSON pequeno e nao ficam presas. Um anexo pode ir ate
// attachment_max_bytes (10 MB por omissao), e mesmo numa ligacao lenta de uns
// 3 Mbps isso demora perto de 27s; 30s da uma margem sem deixar o operador
// preso a um spinner ate o browser desistir sozinho.
const ATTACHMENT_FETCH_TIMEOUT_MS = 30000;

export const conversationsApi = {
  // Uma pagina da lista. Devolve {items, total, next_cursor}.
  //
  // `cursor` e o `next_cursor` da pagina anterior, e e opaco: devolve-se tal e
  // qual e nao se le nada de dentro. Substituiu o `offset` quando a lista passou
  // a ser ordenada pela ultima atividade, no PR #246 do backend: com a chave de
  // ordenacao a mexer, uma conversa que recebe uma mensagem sobe ao topo e empurra
  // as outras uma posicao, portanto `offset: 50` passava a saltar a linha que
  // entretanto desceu para a 50 e a repetir a que estava na 49. O mesmo padrao do
  // fileApi, que ja paginava assim.
  //
  // O servidor ainda aceita `offset`, mas nao os dois ao mesmo tempo: manda 422.
  //
  // Os filtros do CSAT e o periodo pelo fecho (D16 do plano do CSAT na pagina) so vao quando nao sao
  // null, como o `handedOff`: um `false` e um filtro a serio, e nunca o "desligado" (o listFilters).
  list: async ({
    chatId = null,
    contactId = null,
    status = null,
    handedOff = null,
    createdFrom = null,
    createdTo = null,
    resolvedFrom = null,
    resolvedTo = null,
    csatRating = null,
    csatRated = null,
    csatCommented = null,
    csatOperatorId = null,
    withVoice = null,
    limit = 50,
    cursor = null,
  } = {}) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;
    if (chatId) params.chat_id = chatId;
    if (contactId) params.contact_id = contactId;
    if (status) params.status = status;
    if (handedOff !== null) params.handed_off = handedOff;
    if (createdFrom) params.created_from = createdFrom;
    if (createdTo) params.created_to = createdTo;
    if (resolvedFrom !== null) params.resolved_from = resolvedFrom;
    if (resolvedTo !== null) params.resolved_to = resolvedTo;
    if (csatRating !== null) params.csat_rating = csatRating;
    if (csatRated !== null) params.csat_rated = csatRated;
    if (csatCommented !== null) params.csat_commented = csatCommented;
    if (csatOperatorId !== null) params.csat_operator_id = csatOperatorId;
    // So com o filtro ligado: o `false` nunca vai (o D14 le-o como "sem voz", e o viewer nao o pede).
    if (withVoice === true) params.with_voice = true;
    const response = await conversationsApiInstance.get("", { params });
    return response.data;
  },

  // Uma conversa com a transcricao. 404 quando nao existe ou e de outro tenant.
  get: async (conversationId) => {
    const response = await conversationsApiInstance.get(`/${conversationId}`);
    return response.data;
  },

  // Os bytes de um anexo, como Blob.
  //
  // responseType blob e nao json: o corpo sao bytes e o axios so nao lhes toca
  // se lho dissermos. O mesmo padrao do fileApi.getFileContentAsBlob, que e o
  // precedente deste repo para descarregar binario autenticado.
  //
  // PELA INSTANCIA E NAO POR UM fetch A SECO, e a razao e o interceptor: a
  // instancia poe o Bearer, poe o X-Tenant-ID, e traz o createRefreshInterceptor.
  // Isto renova e repete em vez de deixar seis chips partidos, mas so no
  // self-hosted (Radio Popular): ai o middleware do tenant corta primeiro e
  // get_current_user da 401, que e o que o interceptor apanha. No Kodly-hosted
  // a chamada userinfo do middleware rebenta antes disso e o pedido acaba em
  // 400, e createRefreshInterceptor so dispara em error.response?.status ===
  // 401, portanto ali nao ha renovacao nenhuma e os chips partem na mesma. Ir
  // pela instancia continua certo dos dois lados, pelo Bearer, pelo
  // X-Tenant-ID e pelo retry onde ele se aplica; so o resultado no
  // Kodly-hosted e que nao e o que este comentario prometia antes.
  //
  // NUM ERRO, O CORPO TAMBEM E UM BLOB. Com responseType blob o axios nao
  // desserializa a resposta de erro, portanto err.response.data.detail e
  // undefined mesmo num 404 que traz JSON. Quem apanhar isto le o status e nao o
  // detalhe.
  getAttachmentBlob: async (conversationId, attachmentId) => {
    const response = await conversationsApiInstance.get(
      `/${conversationId}/attachments/${attachmentId}`,
      { responseType: "blob", timeout: ATTACHMENT_FETCH_TIMEOUT_MS }
    );
    return response.data;
  },
};
